export enum CustomExceptionTypes {
  LOGIN_ERROR,
  NEED_LOGIN,
  SYS_ERROR,
  UNKNOWN_ERROR,
  CANCELED,
  USER_INPUT_ERROR,
}
